import { Popover, Popconfirm, Row, Col, Tooltip } from "antd";
import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import Animations from "../animations/Animations";

export default function GridButton(props) {
  const {
    tooltip = "",
    title = "",
    icon = "",
    dashed = false,
    children,
    interactive = true,
    onClick = () => {},
    size = 200,
    showDotMenu = true,
    menuActionTitles = [],
    menuActionCallbacks = [],
  } = props;

  const imgIcon =
    icon === ""
      ? "/cms/assets/images/placeholders/grid_icon_placeholder.png"
      : icon;

  const doShowDotMenu = showDotMenu && menuActionTitles.length;
  const renderBody = (isHoveringState) => {
    if (children) {
      return children(isHoveringState);
    } else {
      return (
        <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
          <img
            src={imgIcon}
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
            alt=""
          ></img>
        </div>
      );
    }
  };

  const borderStyle = dashed == true ? "1px dashed" : "1px solid";

  const buttonDimension = `${size}px`;
  const labelHeight = "25px";
  const totalHeight = `${size + 25}px`;

  const [isHovering, setIsHovering] = useState(false);
  const [iconState, setIconState] = useState("icongray");
  const [titleContainerStyle, setTitleContainerStyle] = useState("stilltitle");
  const [isMenuVisible, setIsMenuVisible] = useState(false);

  var currentTitleElement = null;

  var titleStyle = "idletitle";
  // const renderTitle = isHovering ? (<marquee behavior="scroll" direction="left" scrolldelay={100} startVisible={true}>{title}</marquee>) : title

  useEffect(() => {
    if (menuActionTitles.length != menuActionCallbacks.length) {
      throw "The length of menuActionCallbacks must match the length of menuActionTitles";
    }
  }, []);

  useEffect(() => {
    const containerStyle =
      isHovering && title.length > 17 ? "animatedtitle" : "stilltitle";

    if (titleContainerStyle !== containerStyle) {
      setTitleContainerStyle(containerStyle);
    }
    titleStyle = isHovering ? "activetitle" : "idletitle";

    // if (currentTitleElement !== toRender)
    //     setTitleElement(toRender)

    var ics = isHovering ? "iconblue" : "icongray";
    if (iconState !== ics) setIconState(ics);
  }, [isHovering]);

  const hideMenu = () => {
    setIsMenuVisible(false);
  };

  const handleMenuVisibleChange = (visible) => {
    setIsMenuVisible(visible);
  };

  return (
    <motion.div
      initial="initial"
      animate="animate"
      whileTap="tap"
      onMouseEnter={() => {
        setIsHovering(true);
      }}
      onMouseLeave={() => {
        setIsHovering(false);
      }}
      whileHover="hover"
      variants={interactive ? Animations.GRID_BUTTON : ""}
      style={{
        height: totalHeight,
        display: "inline-block",
        margin: "8px 18px",
        cursor: interactive ? "pointer" : "normal",
      }}
    >
      <div style={{ width: buttonDimension, height: totalHeight }}>
        <Tooltip title={tooltip}>
          <div
            span={24}
            style={{
              height: buttonDimension,
              position: "relative",
              borderRadius: "4px",
              boxShadow: "1px 1px 10px rgba(0,0,0, 0.1)",
            }}
          >
            <motion.div
              // whileHover="hover"
              onClick={onClick}
              animate={iconState}
              variants={interactive ? Animations.GRID_BUTTON_ICON : ""}
              style={{
                position: "relative",
                height: totalHeight,
                border: borderStyle,
                backgroundColor: "#fff",
                borderColor: "#EAE9E8",
                borderRadius: "4px",
                width: buttonDimension,
                height: buttonDimension,
                padding: "8px",
                overflow: "hidden",
              }}
            >
              {renderBody(isHovering)}
            </motion.div>
            {doShowDotMenu ? (
              <Popover
                content={
                  menuActionTitles.map((actionTitle, index) => {
                    const callBack = menuActionCallbacks[index];

                    if (actionTitle.toLocaleLowerCase() === "delete") {
                      return (
                        <Popconfirm
                          key={`${actionTitle}-${index}`}
                          title="Are you sure you want to delete this brand?"
                          onConfirm={callBack}
                          onCancel={() => {}}
                          okText="Yes"
                          cancelText="No"
                        >
                          <a href="#">{actionTitle}</a>
                        </Popconfirm>
                      );
                    }
                    return (
                      <div key={`${actionTitle}-${index}`}>
                        <a
                          onClick={() => {
                            hideMenu();
                            callBack();
                          }}
                        >
                          {actionTitle}
                        </a>
                      </div>
                    );
                  })
                  // <>
                  //     <div><a onClick={hideMenu}>Edit</a></div>
                  //     <div><a onClick={hideMenu}>Delete</a></div>
                  // </>
                }
                trigger="click"
                open={isMenuVisible}
                onOpenChange={handleMenuVisibleChange}
              >
                <div
                  style={{
                    position: "absolute",
                    width: "35px",
                    height: "35px",
                    right: "8px",
                    top: 0,
                  }}
                >
                  <img
                    src="/cms/assets/svgs/dotx3_btn.svg"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  ></img>
                </div>
              </Popover>
            ) : null}
          </div>
        </Tooltip>
        <div span={24}>
          <div className="marquee">
            <div className={titleContainerStyle}>
              <span
                className={titleStyle}
                style={{
                  fontSize: "16px",
                  fontWeight: 400,
                  fontFamily: "Kanit",
                  height: labelHeight,
                  lineHeight: { labelHeight },
                  textAlign: "center",
                  whiteSpace: "nowrap",
                }}
              >
                {title}
              </span>
              <span
                className={titleStyle}
                style={{
                  fontSize: "16px",
                  fontWeight: 400,
                  fontFamily: "Kanit",
                  height: labelHeight,
                  lineHeight: { labelHeight },
                  textAlign: "center",
                  whiteSpace: "nowrap",
                }}
              >
                {title}
              </span>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
    // <motion.div
    //     initial="initial"
    //     animate="animate"
    //     whileHover="hover"
    //     variants={Animations.GRID_BUTTON}
    //     style={{ height: totalHeight, display: "inline-block", margin: "20px", cursor: "pointer", overflow: "hidden" }}>
    //     <Row style={{ width: buttonDimension, height: totalHeight }}>
    //         <Col span={24} style={{ height: buttonDimension }}>
    //             <motion.div
    //                 variants={Animations.GRID_BUTTON_ICON}
    //                 style={{ height: totalHeight, border: borderStyle, borderColor: "#C9CACF", borderRadius: "20px", width: buttonDimension, height: buttonDimension, padding: "15px", overflow: "hidden" }}>
    //                 {renderBody}
    //             </motion.div>
    //         </Col>
    //         <Col span={24} style={{ fontSize: "16px", fontWeight: 400, fontFamily: "Kanit", height: labelHeight, overflow: "hidden", textOverflow: "ellipsis", lineHeight: "30px", textAlign: "center", whiteSpace: "nowrap" }}>
    //             {title}
    //         </Col>
    //     </Row>
    // </motion.div>
  );
}
